/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { Initializer, Model } from '@adobe-commerce/elsie/lib';
import { Lang } from '@adobe-commerce/elsie/i18n';
import { OrderHistoryModel } from '@/account/data/models';
import { CustomerDataModelShort } from '@/account/data/models/customer';

type ConfigProps = {
  langDefinitions?: Lang;
  authHeaderConfig?: {
    header?: string;
    tokenPrefix?: string;
  };
  models?: {
    OrderHistoryModel?: Model<OrderHistoryModel>;
    CustomerDataModelShort?: Model<CustomerDataModelShort>;
  };
};

export const initialize = new Initializer<ConfigProps>({
  init: async (config) => {
    const defaultConfig = {
      authHeaderConfig: {
        header: 'Authorization',
        tokenPrefix: 'Bearer',
      },
    };

    initialize.config.setConfig({ ...defaultConfig, ...config });
  },

  listeners: () => [],
});

export const config = initialize.config;
